import { http } from 'connex-cds';


export default {
  deleteConnection: ({ connectionRef }) => http.delete({ apiName: 'support', path: `/connexions/${connectionRef}` }),

};
